const trackPrizes = [
  {
    logo: 'hackillinois.svg',
    title: 'Beginner Track',
    subtitle: 'Staff Pick',
    description: 'Awarded to the best project submitted by a team in which a majority of members identify as beginners (See Attendee Guide for details)',
    subcategories: [
      {
        title: 'First Place',
        prize: '$500',
      },
      {
        title: 'Second Place',
        prize: '$250',
      },
    ],
  },
  {
    logo: 'github.svg',
    title: 'Best Use of Student Developer Pack',
    subtitle: 'Sponsored by Github',
    description: 'Awarded to the project with the best use of Github\'s Student Developer Pack for building websites',
    subcategories: [
      {
        title: 'First Place',
        prize: '$800',
      },
    ],
  },
  {
    logo: 'schlumberger.svg',
    title: 'Data Science Track',
    subtitle: 'Sponsored by Schlumberger',
    description: 'Awarded to the project with the best use of visualization with data science tools and techniques',
    subcategories: [
      {
        title: 'First Place',
        prize: '$800',
      },
    ],
  },
  {
    logo: 'hackillinois.svg',
    title: 'General Track',
    description: 'Awarded to the best project outside of the other provided tracks! Anything you hack up is fair game to take the cake',
    subcategories: [
      {
        title: 'First Place',
        prize: '$800',
      },
    ],
  },
  {
    logo: 'john-deere.svg',
    title: 'Community & Sustainability Track',
    subtitle: 'Sponsored by John Deere',
    description: 'Awarded to the project that provides the best technological solution to an existing community or sustainability issue',
    subcategories: [
      {
        title: 'First Place',
        prize: '$800',
      },
    ],
  },
];

export default trackPrizes;
